import axios from '../../services/httpService';
import { notificationMsg } from '../../utility/Notification';
import { API_URL } from '../../constants/ApiUrls';

// ====================== get =================

export const getDomains = () => async (dispatch) => {
  try {
    const res = await axios(API_URL.GET_ALL_DOMAINS);
    const { data: { domains, non_tech_employees } = [] } = res;
    dispatch({
      type: 'GET_EMAIL_MARKETING_DOMAINS',
      payload: domains,
      array: {
        non_tech_employees,
      },
    });
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
};

// ============== update domain ===============

export const updateDomain = (requestBody) => async (dispatch) => {
  try {
    const res = await axios.post(API_URL.UPDATE_DOMAIN, requestBody);
    dispatch(getDomains());
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
};

// ============== refresh domain ===============

export const refreshDomain = (requestBody) => async (dispatch) => {
  try {
    await axios.post(API_URL.REFRESH_DOMAIN, requestBody);
    dispatch(getDomains());
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
};
